export default "__VITE_ASSET__BeE$w9wE__"